export const NAME = 'blogs'
export const ITEMS_PER_PAGE = 9
